import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';
import { Bs7Circle, BsFillBuildingFill } from 'react-icons/bs';

const EditClasse = ({ selectedClasse, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken,user } = useStateContext();
    const [errors, setErrors] = useState(null);
  
    const [classe, setClasse] = useState({
        classeId: selectedClasse.id,
        capacite: selectedClasse.capacite,
        prix: selectedClasse.prix,
    });
    const navigate = useNavigate();
    useEffect(() => {
       
    }, []);
    const onSubmit = () => {
        setErrors(null);
        setLoading(true);
        axiosClient.put('/classe/update', classe)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

   

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header icon={<BsFillBuildingFill />} title="Modifier une classe" titleAr="تحرير فصل" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                       
                            <>
                                <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                    <div className='flex-col w-full justify-evenly '>
                                        
                                        <div className='mr-2'>
                                            <Input readOnly="readOnly" label="Libelle" type="text" value={selectedClasse.libelle}  required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Def.Prix" labelAr="السعر" type="text" value={classe.prix} onChange={ev => setClasse({ ...classe, prix: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Capacité" labelAr="الإستيعاب" type="text" value={classe.capacite} onChange={ev => setClasse({ ...classe, capacite: ev.target.value })} required="required" />
                                        </div>
                                    </div>
                                </div>
                            </>
                        
                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />

                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditClasse